import styled, { css } from 'styled-components';

import { TextButton } from '@xing-com/button';
import {
  cornerRadiusL,
  spaceS,
  spaceM,
  xdlColorHover,
  xdlColorA11yBorder,
  scale010,
} from '@xing-com/tokens';

type SingleSelectTransientProps = {
  $selected?: boolean;
};

// *** Components ***
export const SingleSelect = styled(TextButton)<SingleSelectTransientProps>`
  && {
    box-sizing: border-box;
    border-radius: ${cornerRadiusL};
    display: flex;
    font-weight: 400;
    height: auto;
    justify-content: flex-start;
    padding-bottom: ${spaceM};
    padding-left: ${spaceS};
    padding-right: ${spaceS};
    padding-top: ${spaceM};
    width: 100%;
    border: ${scale010} solid transparent;

    ${({ $selected }) =>
      $selected &&
      css`
        font-weight: bold;
      `}

    &:hover {
      background: ${xdlColorHover};
      border: ${scale010} solid ${xdlColorA11yBorder};
      text-decoration: none;
    }
  }
`;

export const SingleSelectContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;
